/**
 * medi-nav.js: site chrome behavior, loaded on every page.
 * Bundled by esbuild to static/medi-nav.js.
 */
import { initNav } from '../../features/nav/nav.js';

document.addEventListener('DOMContentLoaded', () => {
  initNav();
});
